export default __webpack_public_path__ + "static/media/oculus.428df74e.glb";